(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["countdown"] && !Shopify.designMode) return;
  try {
    
(function () {
  // Custom daily reset countdown. Runs only when daily_reset is enabled.
  var root = document.querySelector('#shopify-section-{{ section.id }} .time[data-b4u-daily-countdown="true"]');
  if (!root) return;

  var resetHour = parseInt(root.getAttribute('data-reset-hour'), 10);
  var resetMinute = parseInt(root.getAttribute('data-reset-minute'), 10);

  if (isNaN(resetHour) || resetHour < 0 || resetHour > 23) resetHour = 0;
  if (isNaN(resetMinute) || resetMinute < 0 || resetMinute > 59) resetMinute = 0;

  var daysEl  = root.querySelector('[data-unit="days"]');
  var hoursEl = root.querySelector('[data-unit="hours"]');
  var minsEl  = root.querySelector('[data-unit="mins"]');
  var secsEl  = root.querySelector('[data-unit="secs"]');

  if (!daysEl || !hoursEl || !minsEl || !secsEl) return;

  function getNextTarget(now) {
    var target = new Date(now.getTime());
    target.setHours(resetHour, resetMinute, 0, 0);
    if (target <= now) {
      target.setDate(target.getDate() + 1);
    }
    return target;
  }

  var target = getNextTarget(new Date());

  function updateCountdown() {
    var now = new Date();

    if (now >= target) {
      target = getNextTarget(now);
    }

    var diff = target - now;
    if (diff < 0) diff = 0;

    var totalSeconds = Math.floor(diff / 1000);
    var days    = Math.floor(totalSeconds / 86400);
    var hours   = Math.floor((totalSeconds % 86400) / 3600);
    var minutes = Math.floor((totalSeconds % 3600) / 60);
    var seconds = totalSeconds % 60;

    daysEl.textContent  = days;
    hoursEl.textContent = String(hours).padStart(2, '0');
    minsEl.textContent  = String(minutes).padStart(2, '0');
    secsEl.textContent  = String(seconds).padStart(2, '0');
  }

  updateCountdown();
  setInterval(updateCountdown, 1000);
})();

  } catch(e) { console.error(e); }
})();
})();
